import { Box, Divider, List } from '@material-ui/core'

import { DRAWER_SITE_LINKS } from '../../utils/constants/site'
import DrawerProfile from './DrawerProfile'
import ListItemLink from '../ListItemLink'
import React from 'react'
import SocialLogos from '../logos/SocialLogos'

export default function DrawerContent() {
  return (
    <Box>
      <Box my={2}>
        <DrawerProfile />
        <Box mt={2}>
          <SocialLogos />
        </Box>
      </Box>
      <Divider />
      <List component="nav" aria-label="contacts">
        {DRAWER_SITE_LINKS.map(
          (props) =>
            props.isVisible && <ListItemLink key={props.name} {...props} />
        )}
      </List>
    </Box>
  )
}
